import { useQuery } from '@tanstack/react-query';

import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { ImageIcon } from '@gitbook/spine-react';

import { apiQuery } from '../../state';

export function IntegrationIcon({
    integration,
    className = 'w-full',
    size,
}: {
    integration: api.Integration;
    className?: string;
    size?: number;
}) {
    if (integration.urls.icon) {
        return <ImageIcon src={integration.urls.icon} size={size} className={className} />;
    }

    return <Icon.Integrations className={className} size={size} />;
}

/**
 * Icon for an integration by its name.
 */
export function IntegrationIconByName(props: {
    integrationName: string;
    className?: string;
    size?: number;
}) {
    const { integrationName, ...iconProps } = props;
    const { data: integration } = useQuery(apiQuery('getIntegrationByName', { integrationName }));

    if (!integration) {
        return <Icon.Integrations {...iconProps} />;
    }

    return <IntegrationIcon integration={integration} className={props.className} />;
}
